/* eslint-disable  */
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Search, ChevronRight } from "lucide-react";
import Loader from "../../Components/Loader";
import { dataActionCreators } from "../../services/Actions";
import RenderLoanPage from "../RenderLoanPage";
import { ToastContainer, toast } from "react-toastify";
import { GhanaMoneyDisplay } from "../../helpers/helper";
import { GetTotal } from "../../services/Actions/dataAction";

function LoansDeduction() {
  const dispatch = useDispatch();
  const { GetAllLoans, ResetDataResponse } = bindActionCreators(dataActionCreators, dispatch);
  const [limit, setLimit] = useState(20);
  const [search, setSearch] = useState(null);

  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = limit;
  const data = useSelector((state) => state.data);
  const { loans, paginate, response, total_loans } = data;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(loans?.slice(itemOffset, endOffset));
    setPageCount(Number(paginate?.total));
  }, [itemOffset, itemsPerPage, loans]);

  const handlePageClick = (event) => {
    GetAllLoans(true, event.selected + 1, limit, `${search ? "&search=" + search : ""}`);
    const newOffset = (event.selected * itemsPerPage) % paginate?.total;
    setItemOffset(newOffset);
  };

  const onSearchTextChange = debounce((e) => {
    if (e?.target?.value) {
      setSearch(e?.target?.value ?? null);
      GetAllLoans(true, 1, limit, `${e?.target?.value ? "&search=" + e?.target?.value : ""}`);
    } else {
      setSearch(null);
      GetAllLoans(true, 1, limit);
    }
  }, 800);

  useEffect(() => {
    GetAllLoans(true, 1, limit);
    dispatch(GetTotal());
  }, []);

  useEffect(() => {
    GetAllLoans(true, 1, limit, search ? "&search=" + search : "");
  }, [limit]);

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => ResetDataResponse(), 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => ResetDataResponse(), 1500);
    }
  }, [response?.state]);

  return (
    <RenderLoanPage title="Loans Deductions">

      {/* SEARCH & FILTER BAR */}
      <div className="flex flex-col sm:flex-row gap-4 mb-6">
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} />
            <input
              type="search"
              placeholder="Search by Staff ID.."
              className="w-full pl-10 pr-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent shadow-sm"
              onChange={onSearchTextChange}
            />
          </div>
        </div>
        <select
          className="px-4 py-2.5 bg-white border border-slate-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 shadow-sm"
          onChange={(e) => setLimit(e.target.value)}
        >
          <option value={20}>20 per page</option>
          <option value={50}>50 per page</option>
          <option value={100}>100 per page</option>
          <option value={250}>250 per page</option>
          <option value={500}>500 per page</option>
        </select>
      </div>

      {(data?.isLoading || data?.loans?.length > 0) && (
        <section className="bg-white rounded-2xl shadow-sm border border-slate-100 overflow-hidden">
          <div className="p-6 border-b border-slate-50 flex justify-between items-center">
            {/* <h2 className="text-md font-bold text-slate-800">Loans Deductions</h2> */}
            {total_loans && (
              <span className="text-md font-bold text-slate-700">
                Total: <GhanaMoneyDisplay amount={total_loans} />
              </span>
            )}
          </div>

          {data?.isLoading ? (
            <div className="p-6">
              <Loader />
            </div>
          ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="dark:bg-gray-800 bg-slate-50">
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Member Info</th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Amount</th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Period</th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Transaction</th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Facility</th>
                  <th className="px-6 py-4 text-xs font-bold text-slate-500 uppercase tracking-wider text-right">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {data?.loans?.map((loan) => (
                  <tr key={loan?._id} className="hover:bg-slate-50/80 transition-colors">
                    <td className="px-6 py-4">
                      <div className="flex items-center gap-3">
                        <img
                          className="w-10 h-10 rounded-full border border-slate-200 object-cover shadow-sm"
                          src={loan?.user?.profile_image || "/images/dev/avatar1.png"}
                          alt="Profile"
                        />
                        <div>
                          <p className="text-sm font-bold text-slate-800 leading-tight">{loan?.user?.name}</p>
                          <p className="text-xs font-medium text-slate-500">{loan?.staff_id}</p>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4">
                      <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold bg-emerald-50 text-emerald-700 border border-emerald-100">
                        &#8373;{loan?.deduction}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm text-slate-600 font-medium">{loan?.period}</td>
                    <td className="px-6 py-4 text-sm text-slate-600 font-medium">{loan?.transaction_type}</td>
                    <td className="px-6 py-4 text-sm text-slate-600 font-medium">{loan?.user?.facility}</td>
                    <td className="px-6 py-4 text-right">
                      <button className="p-2 text-slate-400 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all">
                        <ChevronRight size={20} />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          )}

          {loans?.length > 0 && (
            <div className="border-t border-slate-100">
              <ReactPaginate
                breakLabel="..."
                nextLabel=">"
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                pageCount={pageCount}
                previousLabel="<"
                renderOnZeroPageCount={null}
                containerClassName="flex items-center justify-center gap-1 py-4"
                pageLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                previousLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                nextLinkClassName="px-3 py-1.5 rounded-lg text-sm font-medium text-slate-600 hover:bg-indigo-50 hover:text-indigo-600 transition-colors"
                activeLinkClassName="!bg-indigo-600 !text-white shadow-sm"
              />
            </div>
          )}
        </section>
      )}
      <ToastContainer autoClose={3000} />
    </RenderLoanPage>
  );
}

export default LoansDeduction;
